import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../utils/withRouter';
import { bindActionCreators, Dispatch } from 'redux';
import { FormattedMessage, injectIntl } from 'react-intl';

import { RootState } from '../../../reducers';
import * as _actionsJourney from '../../../actions/journey1';
import * as _actionsSujet from '../../../actions/sujet';
import BreadCrumbs from '../../../components/BreadCrumbs';
import * as actions from '../../../actions/index';
import { Button, EButtonType } from '@repo/apg-ui';
import SpinnerV2 from '../../../components/SpinnerV2';
import { getIcon, salutation, spottypes } from '../../../utils/mappings';
import ErrorContainer from '../../../components/ErrorContainer/ErrorContainer';
import { useParams } from 'react-router-dom';
import { useNavigate } from 'react-router';
import { PartiallyIntegratedUserDataEC } from '../../../reducers/app';

interface Props {
  actionsJourney: typeof _actionsJourney;
  actionsSujet: typeof _actionsSujet;
  campaignDetails: { comment: string; formats: string; spottype: string; documents: any; contact: any };
  creationDetails: any;
  history: any;
  intl: any;
  isDigital: boolean;
  keycloakReady: any;
  locales: any;
  match: any;
  userDataEC: PartiallyIntegratedUserDataEC;
  validationMessageConfig: any;
}

const CreationOrderConfirmation = ({
  userDataEC: { userInfo },
  history,
  creationDetails,
  intl,
  isDigital,
  keycloakReady,
  actionsSujet,
}: Props) => {
  const params = useParams();
  const comment = creationDetails?.comment;
  const formats = creationDetails?.formats;
  const spottype = creationDetails?.spottype;
  const documents = creationDetails?.documents;
  const contact = creationDetails?.contact;

  const navigate = useNavigate();

  useEffect(() => {
    if (keycloakReady) {
      actionsSujet.getCreationOrder({
        number: params.creationId,
      });
    }
  }, []);

  const renderUserInfo = (userInfoOrder: { firstname: string; title: string | null }, userInfoDataEC) => {
    const userInfo = userInfoOrder && userInfoOrder.firstname && userInfoOrder.title ? userInfoOrder : userInfoDataEC;

    if (userInfo && userInfo.firstname) {
      return (
        <div>
          <p className='m-0'>{salutation[userInfo.title] || userInfo.title}</p>
          <p className='m-0'>
            {userInfo.firstname} {userInfo.lastname || userInfo.surname}
          </p>
          <p className='m-0'>{userInfo.address || userInfo.street}</p>
          <p className='mb-3'>
            {userInfo.zip} {userInfo.city}
          </p>
          <p className='m-0'>{userInfo.email}</p>
          <p className='m-0'>{userInfo.nr}</p>
        </div>
      );
    }

    return null;
  };

  return creationDetails?.formats ? (
    <>
      <BreadCrumbs
        parentPage={null}
        pageName={intl.formatMessage({
          id: 'ec.navigation.CreationOrderConfirmationsKreationsservice',
          defaultMessage: 'CreationOrderConfirmations-/Kreationsservice',
        })}
      />
      <div className='container-fluid journey1  overflow-hidden p-0'>
        <div className='pageContainer'>
          <ErrorContainer journeyType='afterSales' />

          <div className='creationOrder'>
            <div className='row justify-content-start'>
              <h3 className='col-8 mt-3 mb-24 title-text-block fw-bold'>
                {isDigital ? (
                  <FormattedMessage
                    id='as.creationOrderConfirmation.digital.title'
                    defaultMessage='Besten Dank für Ihren Gestaltungs-/Kreationsauftrag zur Kampagne <a>1234567</a>'
                    values={{
                      a: () => (
                        <a
                          rel='noopener noreferrer'
                          href={`${process.env.REACT_APP_PUBLIC_URL}campaign/${params.campaignId}`}
                          target='_blank'
                        >
                          {params.campaignId}
                        </a>
                      ),
                    }}
                  />
                ) : (
                  <FormattedMessage
                    id='as.creationOrderConfirmation.title'
                    defaultMessage='Besten Dank für Ihren Gestaltungs-/Kreationsauftrag zur Kampagne <a>1234567</a>'
                    values={{
                      a: () => (
                        <a
                          rel='noopener noreferrer'
                          href={`${process.env.REACT_APP_PUBLIC_URL}campaign/${params.campaignId}`}
                          target='_blank'
                        >
                          {params.campaignId}
                        </a>
                      ),
                    }}
                  />
                )}
              </h3>
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 mb-24'>
                {isDigital ? (
                  <FormattedMessage
                    id='as.creationOrderConfirmation.digital.first-paragraph'
                    defaultMessage='In Kürze wird sich die beauftrage Partneragentur mit Ihnen in Verbindung setzten. Die Angaben zu diesem Auftrag finden Sie auch jederzeit unter Ihrem Dashboard unter Gebuchte Kampagnen.'
                  />
                ) : (
                  <FormattedMessage
                    id='as.creationOrderConfirmation.first-paragraph'
                    defaultMessage='In Kürze wird sich die beauftrage Partneragentur mit Ihnen in Verbindung setzten. Die Angaben zu diesem Auftrag finden Sie auch jederzeit unter Ihrem Dashboard unter Gebuchte Kampagnen.'
                  />
                )}
              </p>
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 mt-3 fw-bold'>
                <FormattedMessage
                  id='as.creationOrderConfirmation.title2'
                  defaultMessage='Gestaltungs-/Kreationsauftrag zur Kampagne <a>1234567</a> im Überblick'
                  values={{
                    a: () => (
                      <a
                        rel='noopener noreferrer'
                        href={`${process.env.REACT_APP_PUBLIC_URL}campaign/${params.campaignId}`}
                        target='_blank'
                      >
                        {params.campaignId}
                      </a>
                    ),
                  }}
                />
              </p>
            </div>

            {isDigital ? (
              <div className='row my-24 justify-content-start'>
                <p className='col-12 mb-24 fw-bold'>
                  <FormattedMessage id='ec.gestaltung.first-title' defaultMessage='1. Gewählte Umsetzungsform' />
                </p>

                <div className='d-flex align-items-center mb-3 customCheckbox format-input'>
                  <input required className='ms-24' id={spottype} type='checkbox' checked={true} />

                  <span className='d-flex flex-column align-items-center bild-span'>
                    <label htmlFor={spottype}>{spottype && spottypes[spottype]['name']}</label>
                  </span>
                </div>
              </div>
            ) : (
              <div className='row my-24 justify-content-start'>
                <p className='col-12 mb-24 fw-bold'>
                  <FormattedMessage
                    id='as.creationOrderConfirmation.first-title'
                    defaultMessage='1. Gewählte Format(e)'
                  />
                </p>

                {formats &&
                  formats.map((format, idx) => (
                    <div key={`${format}${idx}`} className='d-flex align-items-center mb-3 customCheckbox format-input'>
                      <input required className='ms-24' id={`${format}${idx}input`} type='checkbox' checked={true} />
                      <label htmlFor={format}>
                        {format} {getIcon(format)}
                      </label>
                    </div>
                  ))}
              </div>
            )}

            {isDigital && (
              <div className='row mb-24 justify-content-start'>
                <p className='col-12 mb-24 fw-bold'>
                  <FormattedMessage
                    id='as.creationOrderConfirmation.formatsTitle'
                    defaultMessage='2. Gewählte Format(e)'
                  />
                </p>

                {formats &&
                  formats.map((format, idx) => (
                    <div key={`${format}${idx}`} className='d-flex align-items-center mb-3 customCheckbox format-input'>
                      <input required className='ms-24' id={`${format}${idx}input`} type='checkbox' checked={true} />
                      <label htmlFor={format}>
                        {format} {getIcon(format)}
                      </label>
                    </div>
                  ))}
              </div>
            )}

            <div className='row justify-content-start'>
              <p className='col-12 mb-3 fw-bold mb-24'>
                {isDigital ? '3. ' : '2. '}
                <FormattedMessage
                  id='as.creationOrderConfirmation.third-title'
                  defaultMessage='Hochgeladene Unterlagen'
                />
              </p>

              <div className='col-12 d-flex flex-row flex-wrap mb-24'>
                {documents &&
                  documents.map((documentObj, idx) => (
                    <div className='fileBlock' key={`file-block-doc-${idx}`}>
                      {documentObj.mimetype.includes('video') || documentObj.mimetype.includes('mp4') ? (
                        <video poster={documentObj.mimetype} controls>
                          <source src={documentObj.urloriginal} type={documentObj.mimetype} />
                        </video>
                      ) : (
                        <img src={documentObj.urlthumbnail} alt='Uploaded document' />
                      )}
                    </div>
                  ))}
              </div>

              {comment && (
                <>
                  <p className='col-8 mt-24'>
                    <FormattedMessage id='as.creationOrderConfirmation.bemerkungen' defaultMessage='Bemerkungen:' />
                  </p>

                  <p className='col-8 mb-24'>{comment}</p>
                </>
              )}
            </div>

            <div className='row justify-content-start'>
              <p className='col-8 mb-24 fw-bold'>
                {isDigital ? '4. ' : '3. '}
                <FormattedMessage
                  id='ec.creationOrderConfirmation.myContactDetails'
                  defaultMessage='Meine Kontaktangaben'
                />
              </p>

              <div className='col-9'>
                <div className='d-flex'>
                  <div className='col-6 px-0'>{renderUserInfo(contact, userInfo)}</div>
                </div>
              </div>
            </div>

            <div className='row justify-content-start'>
              <div className='col-9 d-flex twoButtons pe-48'>
                <Button
                  onClick={() => navigate({ pathname: '/campaign/' + params.campaignId })}
                  buttonType={EButtonType.PillMedium}
                >
                  <FormattedMessage id='ec.confirmation.close' defaultMessage='Schliessen' />
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : (
    <SpinnerV2 />
  );
};

function mapStateToProps(state: RootState, ownProps: any) {
  return {
    ...ownProps,
    ...state.app,
    ...state.router,
    locales: state.locales,
  };
}

function mapDispatchToProps(dispatch: Dispatch<actions.ACTION>) {
  return {
    actionsJourney: bindActionCreators(_actionsJourney as any, dispatch),
    actionsSujet: bindActionCreators(_actionsSujet as any, dispatch),
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(CreationOrderConfirmation)));
